import React, { useState, useEffect } from 'react'
import ReactPlayer from 'react-player'
import Row from '../components/Row'
import LivestreamRow from '../components/LivestreamRow'
import api from '../api'

import logo from '../assets/IFE.png'

const Index = props => {
  const [casts, setCasts] = useState([])
  const [url, setUrl] = useState(null)
  const [livestream, setLivestream] = useState(null)
  const [showLive, setShowLive] = useState(false)

  useEffect(() => {
    api.getCloudcasts()
    .then(res => {
      setCasts(res.data)
    })
    .catch(err => console.log({err}))
    api.getLiveStream()
    .then(res => {
      setLivestream(res)
    })
    .catch(err => console.log({err}))
  }, [])

  const handleSetUrl = url => {
    setShowLive(false)
    setUrl(url)
  }

  const handleSetLive = () => {
    setShowLive(true)
    setUrl(null)
  }

  console.log(casts)


  return(
    <div>
      <div style={{ textAlign: 'center', marginTop: '40px' }}>
        <img draggable="false" src={logo} style={{ height: '60px' }}/>
      </div>
      <div className='table'>
        <div className='thead'>
          <div className='th' style={{ width: '20%' }}>
            <p>
              Date
            </p>
          </div>
          <div className='th' style={{ width: '55%' }}>
            <p>
              Show
            </p>
          </div>
          <div className='th' style={{ width: '25%' }}>
            <p>
              Duration
            </p>
          </div>
        </div>
        <div className='tbody'>
          { livestream && <LivestreamRow livestream={livestream} handleClick={handleSetLive}/> }
          { casts.map(item => <Row item={item} handleClick={handleSetUrl} key={item.key}/>  )}
        </div>
      </div>
      {
        showLive &&
        <iframe 
          style={{
            position: 'absolute',
            bottom: '0px',
            filter: 'invert(1)'
          }}
          id='stream'
          src="https://mixlr.com/users/8931262/embed" 
          width="100%" 
          height="180px" 
          scrolling="no" 
          frameborder="no" 
          marginheight="0" 
          marginwidth="0"
        />
      }
      <ReactPlayer 
        className='react-player' 
        url={url}
        config={{
          mixcloud: {
            options: {
              mini: true,
            }
          }
        }}
      />
    </div>
  )

}

export default Index